/**
 * Product page — VIP earn preview (Ray's Loyalty GET earn + tier multipliers).
 */
(function () {
  'use strict';

  var PREVIEW_TIER_MULT = {
    'gold-queen': 'goldMultiplier',
    'mocha-queen': 'mochaMultiplier',
  };

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function readConfig(wrapper) {
    var node = qs(wrapper, '[data-rl-vip-config]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function formatPoints(n) {
    var v = Math.max(0, Math.floor(Number(n) || 0));
    try {
      return v.toLocaleString();
    } catch (e) {
      return String(v);
    }
  }

  function formatMultiplier(n) {
    var v = Number(n);
    if (!Number.isFinite(v) || v <= 0) return '1×';
    var s = String(v);
    if (s.indexOf('.') >= 0) s = s.replace(/\.?0+$/, '');
    return s + '×';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyPlaceholders(text, ctx) {
    var out = String(text == null ? '' : text);
    out = out.split('[[points]]').join(ctx.pointsLabel);
    out = out.split('[[multiplier]]').join(ctx.multiplierLabel);
    return out;
  }

  function renderLine(text, highlight, ctx) {
    var raw = applyPlaceholders(text, ctx).trim();
    if (!raw) return '';
    var hi = applyPlaceholders(highlight, ctx).trim();
    if (!hi || raw.indexOf(hi) < 0) {
      return escapeHtml(raw);
    }
    var parts = raw.split(hi);
    var html = '';
    for (var i = 0; i < parts.length; i++) {
      if (i > 0) {
        html +=
          '<span class="product-cell-tag-highlight">' + escapeHtml(hi) + '</span>';
      }
      html += escapeHtml(parts[i]);
    }
    return html;
  }

  function fallbackGuestPoints(priceCents, rate) {
    var r = Number(rate);
    if (!Number.isFinite(r) || r <= 0) r = 1;
    return Math.max(0, Math.floor((priceCents / 100) * r));
  }

  function effectivePoints(earn, priceCents, cfg) {
    if (!earn) {
      return fallbackGuestPoints(priceCents, 1);
    }
    if (earn.guest) {
      var gp = Math.max(0, Math.floor(Number(earn.points) || 0));
      return gp > 0 ? gp : fallbackGuestPoints(priceCents, earn.rate);
    }
    var points = Math.max(0, Math.floor(Number(earn.points) || 0));
    var handle = String(earn.tierHandle || '');
    var key = PREVIEW_TIER_MULT[handle];
    if (!key || !cfg) return points;
    var previewMult = Number(cfg[key]);
    var apiMult = Number(earn.tierMultiplier);
    var rate = Number(earn.rate);
    if (
      Number.isFinite(previewMult) &&
      previewMult > 0 &&
      Number.isFinite(rate) &&
      priceCents > 0 &&
      (!Number.isFinite(apiMult) || apiMult < previewMult - 0.0001)
    ) {
      return Math.max(
        0,
        Math.floor((priceCents / 100) * rate * previewMult * (Number(earn.dateMultiplier) || 1))
      );
    }
    return points;
  }

  function effectiveMultiplier(earn, cfg) {
    if (!earn || earn.guest) return 1;
    var apiMult = Number(earn.tierMultiplier);
    if (Number.isFinite(apiMult) && apiMult > 0) return apiMult;
    var handle = String(earn.tierHandle || '');
    var key = PREVIEW_TIER_MULT[handle];
    if (key && cfg) {
      var pm = Number(cfg[key]);
      if (Number.isFinite(pm) && pm > 0) return pm;
    }
    return 1;
  }

  function openShopifyAccountSheet() {
    if (window.RaysLoyalty && typeof window.RaysLoyalty.openAccountSheet === 'function') {
      return window.RaysLoyalty.openAccountSheet();
    }
    if (window.HeaderAccount && typeof window.HeaderAccount.openSheet === 'function') {
      return window.HeaderAccount.openSheet();
    }
    return false;
  }

  function resolveLoggedIn(wrapper) {
    if (wrapper.dataset.rlVipLoggedIn === '1') {
      return Promise.resolve(true);
    }
    if (wrapper.dataset.rlVipLoggedIn === '0') {
      return Promise.resolve(false);
    }
    if (wrapper.dataset.liquidLoggedIn === '1') {
      wrapper.dataset.rlVipLoggedIn = '1';
      return Promise.resolve(true);
    }
    var RL = window.RaysLoyalty;
    if (!RL) {
      wrapper.dataset.rlVipLoggedIn = '0';
      return Promise.resolve(false);
    }
    if (RL.syncStorefrontTokenFromWebComponents) {
      RL.syncStorefrontTokenFromWebComponents();
    }
    var cfgRoot = window.__RAYS_LOYALTY__ || {};
    if (cfgRoot.customerId) {
      wrapper.dataset.rlVipLoggedIn = '1';
      return Promise.resolve(true);
    }
    if (RL.getCustomerStorefrontSummary) {
      return RL.getCustomerStorefrontSummary()
        .then(function (sum) {
          if (sum && sum.shopifyCustomerId) {
            cfgRoot.customerId = String(sum.shopifyCustomerId);
            wrapper.dataset.rlVipLoggedIn = '1';
            return true;
          }
          return RL.getTier()
            .then(function (tr) {
              if (tr && tr.shopifyCustomerId) {
                cfgRoot.customerId = String(tr.shopifyCustomerId);
                wrapper.dataset.rlVipLoggedIn = '1';
                return true;
              }
              wrapper.dataset.rlVipLoggedIn = '0';
              return false;
            })
            .catch(function () {
              wrapper.dataset.rlVipLoggedIn = '0';
              return false;
            });
        })
        .catch(function () {
          wrapper.dataset.rlVipLoggedIn = '0';
          return false;
        });
    }
    wrapper.dataset.rlVipLoggedIn = '0';
    return Promise.resolve(false);
  }

  function paintLines(wrapper, cfg, loggedIn, earn, priceCents) {
    var points = effectivePoints(earn, priceCents, cfg);
    var mult = effectiveMultiplier(earn, cfg);
    var ctx = {
      pointsLabel: formatPoints(points),
      multiplierLabel: formatMultiplier(mult),
    };
    var lines = loggedIn
      ? [
          { n: 1, text: cfg.loggedLine1, hi: cfg.loggedLine1Highlight },
          { n: 2, text: cfg.loggedLine2, hi: cfg.loggedLine2Highlight },
        ]
      : [
          { n: 1, text: cfg.guestLine1, hi: cfg.guestLine1Highlight },
          { n: 2, text: cfg.guestLine2, hi: cfg.guestLine2Highlight },
        ];

    lines.forEach(function (line) {
      var row = qs(wrapper, '[data-rl-vip-line="' + line.n + '"]');
      if (!row) return;
      var textEl = qs(row, '[data-rl-vip-line-text]');
      var html = renderLine(line.text, line.hi, ctx);
      if (!html) {
        row.hidden = true;
        return;
      }
      row.hidden = false;
      if (textEl) textEl.innerHTML = html;
    });
  }

  function refresh(wrapper) {
    var cfg = readConfig(wrapper);
    var priceCents = Number(wrapper.dataset.priceCents) || 0;
    var RL = window.RaysLoyalty;
    if (!RL || !RL.getEarn) {
      paintLines(wrapper, cfg, wrapper.dataset.liquidLoggedIn === '1', null, priceCents);
      return Promise.resolve();
    }
    return resolveLoggedIn(wrapper).then(function (loggedIn) {
      return RL.getEarn(priceCents)
        .then(function (earn) {
          paintLines(wrapper, cfg, loggedIn, earn || {}, priceCents);
          wrapper.dataset.rlVipTier = earn && earn.tierHandle ? earn.tierHandle : '';
        })
        .catch(function () {
          paintLines(wrapper, cfg, loggedIn, null, priceCents);
        });
    });
  }

  function bindTrigger(wrapper, cfg) {
    var trigger = qs(wrapper, '[data-rl-vip-trigger]');
    if (!trigger || trigger.dataset.rlVipBound === '1') return;
    trigger.dataset.rlVipBound = '1';
    trigger.addEventListener(
      'click',
      function (e) {
        var loggedIn = wrapper.dataset.rlVipLoggedIn === '1';
        if (!loggedIn) {
          if (cfg.hasModal) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
          openShopifyAccountSheet();
          return;
        }
        if (!cfg.hasModal && cfg.vipPageUrl) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = cfg.vipPageUrl;
        }
      },
      true
    );
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.rlVipInit === '1') return;
    wrapper.dataset.rlVipInit = '1';
    var cfg = readConfig(wrapper);
    bindTrigger(wrapper, cfg);
    refresh(wrapper);
  }

  function initScope(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-rl-vip-cell]').forEach(initWrapper);
  }

  function basisCentsForVariant(wrapper, variant) {
    if (!wrapper || !variant) return 0;
    var script = qs(wrapper, 'script.rays-loyalty-vip__basis-by-variant');
    if (script) {
      try {
        var map = JSON.parse(script.textContent);
        var raw = map[String(variant.id)];
        if (raw != null && raw !== '') return Number(raw);
      } catch (e) {
        /* ignore */
      }
    }
    return Number(variant.price) || 0;
  }

  function onVariantChange(event) {
    if (!event || !event.data || !event.data.variant) return;
    var sectionId = event.data.sectionId;
    var variant = event.data.variant;
    document.querySelectorAll('[data-rl-vip-cell]').forEach(function (wrapper) {
      if (sectionId && wrapper.dataset.sectionId !== String(sectionId)) return;
      wrapper.dataset.priceCents = String(basisCentsForVariant(wrapper, variant));
      refresh(wrapper);
    });
  }

  function bindAccountCloseRefresh() {
    if (document.documentElement.dataset.rlVipAccountCloseBound === '1') return;
    document.documentElement.dataset.rlVipAccountCloseBound = '1';
    document.addEventListener('rays-loyalty:account-sheet-close', function () {
      document.querySelectorAll('[data-rl-vip-cell]').forEach(function (wrapper) {
        wrapper.dataset.rlVipLoggedIn = '';
        refresh(wrapper);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScope();
    bindAccountCloseRefresh();
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });

  document.addEventListener('rays-loyalty:customer-id', function () {
    document.querySelectorAll('[data-rl-vip-cell]').forEach(function (wrapper) {
      wrapper.dataset.rlVipLoggedIn = '';
      refresh(wrapper);
    });
  });
})();
